// extracted by mini-css-extract-plugin
export default {"liffMessenger":"Customer_liffMessenger__inOSw","btnDiv":"Customer_btnDiv__rsvRo","btnLogout":"Customer_btnLogout__ZrscR"};